module.exports = __webpack_public_path__ + "static/media/Modlin_Group_Eduardo_500.be8881a5.jpg";